import React, { PureComponent } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Helmet from 'react-helmet';

import { getNonPassiveHandlerOptions } from 'utils/detectPassiveEvents';
import isTouchActionNoneSupported from 'utils/featureDetection/touchActionNone';

export default class MobileOverlay extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  state = { server: true };

  componentDidMount() {
    this.setState({ server: false }); // eslint-disable-line react/no-did-mount-set-state
  }

  onOverlayCreated = (overlayElement) => {
    if (overlayElement && !isTouchActionNoneSupported()) {
      // touchstart is need to prevent scrolling for browsers not supporting css property touch-action: none
      // unfortunately touchstart need to be attached by hand to be able to call event.preventDefault()
      // reason: https://developers.google.com/web/updates/2017/01/scrolling-intervention
      overlayElement.addEventListener('touchstart', this.onOverlayClick, getNonPassiveHandlerOptions());
    }
  };

  onOverlayClick = (event) => {
    event.preventDefault(); // does nothing for passive touchstart event
    this.props.onClose();
  };

  render() {
    if (this.state.server) {
      // createPortal doesn't work on server side
      return null;
    }

    const { className, open } = this.props;

    return createPortal(
      <div
        className={classNames('overlay', 'overlay-menu', className, { open })}
        ref={this.onOverlayCreated}
        onClick={this.onOverlayClick}
        role="presentation"
      >
        {open && (
          <Helmet>
            {/* It has to be done as an attribute as React Helmet doesn't support css class appending */}
            <body data-u-overflow-hide="true" />
          </Helmet>
        )}
      </div>,
      document.getElementById('modal-root'),
    );
  }
}
